var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.scenicSpotOrders}},[_c('el-table-column',{attrs:{"prop":"area_name","label":"套餐名称"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nick_name","label":"昵称"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"area_price","label":"套餐价格"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87e7c8c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PackageOrders.vue
// module id = null
// module chunks = 